// extracted by mini-css-extract-plugin
export var quantityInput = "_ok-0";